import { defineMessages } from 'react-intl-next';

export default defineMessages({
    cardConnectorTitle: {
        defaultMessage: 'More help resources from {provider} are available',
        description: 'third party auth card title',
        id: 'third-party-connectors.connectors.card-connectors.card-connector-title',
    },
    cardConnectorDescription: {
        defaultMessage: 'Connect your account to improve search results.',
        description: 'third party auth card description',
        id: 'third-party-connectors.connectors.card-connectors.card-connector-description',
    },
    connectButton: {
        defaultMessage: 'Connect',
        description: 'Authentication Button Label',
        id: 'third-party-connectors.connectors.card-connectors.connect-button',
    },
});
